import { MenuItem, Select } from "@mui/material";

export const activeStatusOperators = [
  {
    label: "is",
    value: "isActiveString",
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value) return null;
      return (params) => {
        const val = params.row.isActive ? "Active" : "Inactive";
        return val.toLowerCase() === filterItem.value.toLowerCase();
      };
    },
    InputComponent: (props) => {
      return (
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={props.item.value || ""}
          label="Active Status"
          style={{ width: "100%", height: "100%" }}
          onChange={(e) => {
            props.applyValue({ ...props.item, value: e.target.value });
          }}
        >
          <MenuItem value="">--Select--</MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </Select>
      );
    },
  },
];
